import { Stack } from '@material-ui/core';
import { Skeleton } from '@mui/material';
import React from 'react';

import { DocumentsTabStyledContainer } from './StyledComponents';

function DocumentsTabSkeleton() {
  return (
    <DocumentsTabStyledContainer>
      <Stack spacing={6} direction={'row'}>
        <Skeleton variant="text" sx={{ fontSize: '1.5rem' }} width={65} />
        <Skeleton variant="text" sx={{ fontSize: '1.5rem' }} width={150} />
      </Stack>
      <Stack direction={'row'}>
        <Skeleton variant="rounded" sx={{ marginBottom: '50px' }} width={350} height={60} />
      </Stack>
      <Stack spacing={6} direction={'row'}>
        <Skeleton variant="rounded" width={75} height={50} />
        <Skeleton variant="rounded" width={75} height={50} />
        <Skeleton variant="rounded" width={75} height={50} />
        <Skeleton variant="rounded" width={75} height={50} />
      </Stack>
      <Stack spacing={'20px'} direction={'column'}>
        <Skeleton variant="rounded" width={'100%'} height={225} />
        <Skeleton variant="rounded" width={'100%'} height={225} />
      </Stack>
    </DocumentsTabStyledContainer>
  );
}

export { DocumentsTabSkeleton };
